// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;
  /* Sends the video behind the content */
}

.video-background video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* iOS Safari’daki başlangıç butonunu gizle */
video::-webkit-media-controls-start-playback-button {
  display: none !important;
  -webkit-appearance: none;
}

/* Android WebView ve Chrome’da bazen çıkan kontrolleri gizlemek için */
video::-webkit-media-controls {
  display: none !important;
}

/* Genel olarak video kontrollerini kapat */
video {
  /* controls attribute eklemediğimiz sürece normalde çıkmaz; 
     fakat mobilde poster/play overlay’i gizlemek için aşağıdakileri ekleyebiliriz */
  outline: none;
}

/* Bazı Android cihazlarda ekstra kontroller koyabiliyor; gizleyelim */
video::-webkit-media-controls-enclosure {
  display: none !important;
}

/* .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(226, 98, 107, 0.2); /* Hafif kızıl katman */
/* z-index: 1;
  } */`, "",{"version":3,"sources":["webpack://./src/container/profile/authentication/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,uEAAuE;AACvE;EACE,wBAAwB;AAC1B;;AAEA,2CAA2C;AAC3C;EACE;oFACkF;EAClF,aAAa;AACf;;AAEA,sEAAsE;AACtE;EACE,wBAAwB;AAC1B;;AAEA;;;;;;sEAMsE;AACtE;KACK","sourcesContent":[".video-background {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  z-index: -1;\r\n  /* Sends the video behind the content */\r\n}\r\n\r\n.video-background video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n}\r\n\r\n/* iOS Safari’daki başlangıç butonunu gizle */\r\nvideo::-webkit-media-controls-start-playback-button {\r\n  display: none !important;\r\n  -webkit-appearance: none;\r\n}\r\n\r\n/* Android WebView ve Chrome’da bazen çıkan kontrolleri gizlemek için */\r\nvideo::-webkit-media-controls {\r\n  display: none !important;\r\n}\r\n\r\n/* Genel olarak video kontrollerini kapat */\r\nvideo {\r\n  /* controls attribute eklemediğimiz sürece normalde çıkmaz; \r\n     fakat mobilde poster/play overlay’i gizlemek için aşağıdakileri ekleyebiliriz */\r\n  outline: none;\r\n}\r\n\r\n/* Bazı Android cihazlarda ekstra kontroller koyabiliyor; gizleyelim */\r\nvideo::-webkit-media-controls-enclosure {\r\n  display: none !important;\r\n}\r\n\r\n/* .overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(226, 98, 107, 0.2); /* Hafif kızıl katman */\r\n/* z-index: 1;\r\n  } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
